import * as _4 from 'lodash4';
import { MajorService } from '../../../src/data/services/major_service';
import { MajorTileFunction } from '../../data/functions/major_tile_fn';
import { MajorDataToggleService } from '../../data/services/major_data_toggle_service';
import { IMajorGeneralFlag } from '../../major_explorer_interface';
import { MajorProgram } from './../../data/builders/major_programs_builder';

export class MajorTileController {
  private banner: string;
  private bannerColor: string;
  private major: MajorProgram;
  private favoriteCallback: () => void;
  private flags: IMajorGeneralFlag;
  private bannerColorStyle: object;

  constructor(
    private $state: ng.ui.IStateService,
    private majorDataToggleService: MajorDataToggleService,
    private majorTileFn: MajorTileFunction,
    private ngMajorService: MajorService
  ) {}

  $onInit(): void {
    this.bannerColorStyle = this.bannerColor ? { 'background-color': this.bannerColor } : {};
    this.flags = {
      showSalary: this.majorDataToggleService.toggles.salary,
      showJobDemand: this.majorDataToggleService.toggles.hiringDemand,
      showTuition: this.majorDataToggleService.toggles.tution,
      showDevCourses: this.majorDataToggleService.toggles.devCourses,
      showCourseMaps: this.majorDataToggleService.toggles.courseMaps,
      showCredits: this.majorDataToggleService.toggles.credits,
      showCredentials: !_4.isEmpty(this.major.short_credential)
    };
  }

  get majorSalary(): string {
    return this.ngMajorService.getMajorSalaryString(this.major);
  }

  goToDetail(): void {
    this.$state.go('my.majorDetail', {
      id: this.major.id,
      isFavorite: !!this.favoriteCallback
    });
  }
}

export class MajorTileComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-major-explorer/src/components/major_tile/major_tile.html';
  public controller: any = MajorTileController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    banner: '@',
    bannerColor: '@',
    major: '<',
    favoriteCallback: '&?'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/components/major_tile/major_tile_controller.ts